<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<h1>Acknowledgement</h1>
<p>I wish to express my gratitude for the excellent services rendered to Tommy, Bobby, and Daisy, by Mary Lynn Lackie, DVM, and Elizabeth Motluk, DVM, (Village Veterinary Clinic); Nicole Lalande (Eastway Pet Resort); Lynn Menard (Everything Raw Doggie Café); Chloé Bissonnette (Aux Pitous Adorables); Madison Peterman (Groomer Madison); and John Philip Stratton (John Philip Photography).</p><br/>
<p style="text-indent: 0em;">I also wish to express my gratitude the editing services rendered by Adam Paul (Fiverr), and Julie Wehbe (Julie Wehbe Online Services LTD).</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?1e181eb0